var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.features),function(feature){return _c('div',[_c('img',{staticClass:"feature-image",style:({
                left: feature.location + 'px'
            }),attrs:{"src":feature.path}})])}),_vm._l((_vm.trees),function(tree){return _c('div',[_c('img',{staticClass:"tree-image",style:({
                left: tree.location + 'px'
            }),attrs:{"src":tree.path}})])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }